export default [
    {
        key: 'ManualDistributeModal',
        getComponent: function () { return import('./ManualDistributeModal'); },
        width: 600,
        title: i18n.get('业务对象下发'),
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'AutomaticDistributeModal',
        getComponent: function () { return import('./AutomaticDistributeModal'); },
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'DimensionSelectModal',
        getComponent: function () { return import('./DimensionSelectModal'); },
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
    {
        key: 'RuleConfigurationModal',
        getComponent: function () { return import('./RuleConfigurationModal'); },
        title: i18n.get('规则设置'),
        width: 500,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
];
